import React, { useState } from "react";
import { Typography, Tooltip, Snackbar } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function CopiedText({ text, style = {} }: { text: string; style?: React.CSSProperties }) {
  const [copyToastOpen, setCopyToastOpen] = useState<boolean>(false);
  const [copyToastPos, setCopyToastPos] = useState<{
    top: number;
    left: number;
  } | null>(null);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Tooltip title={text || ""} arrow placement="top">
          <Typography
            variant="body2"
            style={{
              fontSize: "12px",
              color: "#7152F3",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: 160,
              ...style,
            }}
          >
            {text}
          </Typography>
        </Tooltip>
        <Tooltip title="Copy" arrow>
          <button
            onClick={(e) => {
              if (!text) return;
              navigator.clipboard?.writeText(text);
              const offset = 10;
              setCopyToastPos({
                top: e.clientY - offset,
                left: e.clientX + offset,
              });
              setCopyToastOpen(true);
            }}
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              marginLeft: 6,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              color: "#7152F3",
            }}
            aria-label="Copy employee id"
            title="Copy"
          >
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          </button>
        </Tooltip>
      </div>

      <Snackbar
        open={copyToastOpen}
        onClose={() => {
          setCopyToastOpen(false);
          setCopyToastPos(null);
        }}
        autoHideDuration={1500}
        message="Copied"
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          "&.MuiSnackbar-root": {
            position: "fixed",
            top: `${copyToastPos?.top ?? 0}px`,
            left: `${copyToastPos?.left ?? 0}px`,
            transform: "none",
          },
        }}
      />
    </div>
  );
}
